module.exports = ($scope, Api) ->
